import { useMemo } from "react";
import { IAvisEditableListFieldConfig } from "../types";

interface IAvisEditableListHeaderValueProps<P extends object> {
  field: IAvisEditableListFieldConfig<P>;
  disabled: boolean | undefined;
}
export function AvisEditableListHeaderValue<P extends object>(
  props: Readonly<IAvisEditableListHeaderValueProps<P>>,
) {
  const { field, disabled } = props;
  const tooltip = useMemo(() => field.description ?? field.title, [field]);

  //Workaround to draw asterix as used in inputField labels
  return (
    <div className="editable-list-header-value dots-input" title={tooltip}>
      {/* Used this wrapping container (dots-input) to draw asterix correctly */}
      <div className="dots-input-label cell-content">
        <span>
          {field.title}
          {field.required && !disabled && (
            <i className="dots-asterisk fas fa-asterisk" />
          )}
        </span>
      </div>
    </div>
  );
}
